import React, { useEffect, useState } from 'react'
import { Col, ProgressBar, Row } from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import CardCustom from '../../components/custom/card-custom'
import { Outlet } from 'react-router-dom'
import NavbarEmpInfo from '../../components/my-profile/navbar-emp-info'
import TextNavTitle from '../../components/TextNavTitle'
import { getPercentAPI } from '../../services/certificate'
import { useDispatch, useSelector } from 'react-redux'

export default function MyProfilePage() {
  const percent = useSelector((state) => state.profilePercentReducer.percent)
  const dispatch = useDispatch()
  useEffect(() => {
    getPercent()
  }, [percent])

  const getPercent = async () => {
    const res = await getPercentAPI()
    if (!res) return
    if (res.status) {
      dispatch({ type: 'SET_PERCENT', payload: res.result1.percentAll ?? '' })
    }
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>My Profile</TextNavTitle>
      </NavTitle>

      <Col xl={12} className="mb-4">
        <div className="mb-2 mt-2">
          <ProgressBar now={percent} label={`${percent}%`} />{' '}
        </div>
        <CardCustom>
          <NavbarEmpInfo />
          <div className="p-3">
            <Outlet />
          </div>
        </CardCustom>
      </Col>
    </Row>
  )
}
